<template>
<Form
	ref="form"
	class="m-0 p-0 g-0"
	@submit="onSubmit"
	@invalid-submit="console.log"
	:validation-schema="schema"
	:initial-values="formValues"
	v-slot="{ values, errors, meta, isSubmitting, }"
>
<fieldset class="" :disabled="!isFormEnabled">
	<div style="display: none;">
		{{ formMeta = meta }}
		{{ isSubmittingForm = isSubmitting }}
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 mt-1">
			<label class="fw-bold">
				Первинні налаштування
			</label>
		</div>
		
		<div class="col-12 col-xl-6 mt-1">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.unitVersion] }}
			</label>
			<Field
				:name="`${Breaker.passportKeys.unitVersion}`"
				as="select"
				class="form-control form-control-sm"
				:class="{
					'is-invalid': errors[Breaker.passportKeys.unitVersion]
				}"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<template v-for="[key, value] of Object.entries(Breaker.versionNames)" :key="key">
					<option :value="key">{{ value }}</option>
				</template>
				<!-- <option :value="Breaker.versions.v2025">2025УН</option>
				<option :value="Breaker.versions.unknown">невідома</option> -->
			</Field>
			<div class="invalid-feedback">
				{{ errors[Station.passportKeys.breaker.unitVersion] }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>
		
	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.unitPort] }}
			</label>
			<Field
				:name="Breaker.passportKeys.unitPort"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{
					'is-invalid': errors[Breaker.passportKeys.unitPort]
				}"
			/>
			<div class="invalid-feedback">
				{{errors[Breaker.passportKeys.unitPort]}}
			</div>
		</div>

		<div class="col-12 col-xl-6">
			<div class="bg-body border-radius px-3 py-2">
				<span class="form-text fst-italic">
					&nbsp;
				</span>
			</div>
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.unitModbusAddr] }}
			</label>
			<Field
				:name="Breaker.passportKeys.unitModbusAddr"
				type="text"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors[Breaker.passportKeys.unitModbusAddr] }"
			/>
			<div class="invalid-feedback">
				{{errors[Breaker.passportKeys.unitModbusAddr]}}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<a :id="sections.network.anchor" class="anchor-shift" />
	<span ref="networkRef">
	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 mt-4">
			<label class="fw-bold">
				{{ sections.network.title }}
			</label>
		</div>

		<div class="col-12 col-xl-6 mt-1">
			<label>{{ Breaker.settingNames[Breaker.passportKeys.powerUnitAddr] }}</label>
			<Field
				:name="Breaker.passportKeys.powerUnitAddr"
				type="text"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors[Breaker.passportKeys.powerUnitAddr] }"
			/>
			<div class="invalid-feedback">
				{{errors[Breaker.passportKeys.powerUnitAddr]}}
			</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.powerUnitAddr)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.powerUnitAddr)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.serviceUnitAddr] }}
			</label>
			<Field
				:name="Breaker.passportKeys.serviceUnitAddr"
				type="text"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors[Breaker.passportKeys.serviceUnitAddr] }"
			/>
			<div class="invalid-feedback">
				{{errors[Breaker.passportKeys.serviceUnitAddr]}}
			</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.serviceUnitAddr)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.serviceUnitAddr)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.breakerAddr] }}
			</label>
			<Field
				:name="Breaker.passportKeys.breakerAddr"
				type="text"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors[Breaker.passportKeys.breakerAddr] }"
			/>
			<div class="invalid-feedback">
				{{errors[Breaker.passportKeys.breakerAddr]}}
			</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.breakerAddr)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.breakerAddr)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.rs485MasterSpeed] }}
			</label>
			<Field
				:name="`${Breaker.passportKeys.rs485MasterSpeed}`"
				as="select"
				class="form-control form-control-sm"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option v-for="speed in Breaker.rs485SpeedList" :key="speed" :value="speed">
					{{ speed }}
				</option>
			</Field>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.rs485MasterSpeed)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.rs485MasterSpeed)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.rs485MasterStopBits] }}
			</label>
			<Field
				:name="`${Breaker.passportKeys.rs485MasterStopBits}`"
				as="select"
				class="form-control form-control-sm"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option :value="1">1</option>
				<option :value="2">2</option>
			</Field>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.rs485MasterStopBits)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.rs485MasterStopBits)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.rs485SlaveSpeed] }}
			</label>
			<Field
				:name="`${Breaker.passportKeys.rs485SlaveSpeed}`"
				as="select"
				class="form-control form-control-sm"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option v-for="speed in Breaker.rs485SpeedList" :key="speed" :value="speed">
					{{ speed }}
				</option>
			</Field>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.rs485SlaveSpeed)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.rs485SlaveSpeed)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.rs485SlaveStopBits] }}
			</label>
			<Field
				:name="`${Breaker.passportKeys.rs485SlaveStopBits}`"
				as="select"
				class="form-control form-control-sm"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option :value="1">1</option>
				<option :value="2">2</option>
			</Field>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.rs485SlaveStopBits)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.rs485SlaveStopBits)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>
	</span>

	<a :id="sections.modes.anchor" class="anchor-shift" />
	<span ref="modesRef">
	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 mt-4">
			<label class="fw-bold">
				Режим роботи
			</label>
		</div>
		
		<div class="col-12 col-xl-6 mt-1">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.breakerMode] }}
			</label>
			<Field
				:name="`${Breaker.passportKeys.breakerMode}`"
				as="select"
				class="form-control form-control-sm"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option :value="0">Переривання заборонені</option>
				<option :value="1">Переривання дозволені</option>
			</Field>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.breakerMode)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.breakerMode)?.value == 0 ? 'Переривання заборонені' : 'Переривання дозволені' }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.noGpsPowerUnitMode] }}
			</label>
			<Field
				:name="`${Breaker.passportKeys.noGpsPowerUnitMode}`"
				as="select"
				class="form-control form-control-sm"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<option :value="0">Струм дозволений</option>
				<option :value="1">Струм заборонено</option>
			</Field>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.noGpsPowerUnitMode)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.noGpsPowerUnitMode)?.value == 0 ? 'Струм дозволений' : 'Струм заборонено' }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.currentOnDuration] }}
			</label>
			<Field
				:name="Breaker.passportKeys.currentOnDuration"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[Breaker.passportKeys.currentOnDuration] }"
			/>
			<div class="invalid-feedback">
				{{errors[Breaker.passportKeys.currentOnDuration]}}
			</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.currentOnDuration)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.currentOnDuration)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>
				{{ Breaker.settingNames[Breaker.passportKeys.currentOffDuration] }}
			</label>
			<Field
				:name="Breaker.passportKeys.currentOffDuration"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors[Breaker.passportKeys.currentOffDuration] }"
			/>
			<div class="invalid-feedback">
				{{errors[Breaker.passportKeys.currentOffDuration]}}
			</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.currentOffDuration)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.currentOffDuration)?.value }}
			</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>
	</span>

	<a :id="sections.akkumulator.anchor" class="anchor-shift" />
	<div
		ref="akkumulatorRef"
		class="form-row row m-0 p-0 g-3"
	>
		<div class="col-12 mt-4">
			<label class="fw-bold">
				Вимірювання напруги на акумуляторі
			</label>
		</div>
		
		<div class="col-12 col-xl-6 mt-1">
			<label class="mt-1">
				{{ Breaker.settingNames[Breaker.passportKeys.akkEmptyVoltage] }}
			</label>
			<Field
				:name="Breaker.passportKeys.akkEmptyVoltage"
				type="number"
				class="form-control form-control-sm no-arrow mt-1"
				:class="{'is-invalid': errors[Breaker.passportKeys.akkEmptyVoltage] }"
			/>
			<div class="invalid-feedback">
				{{ errors[Breaker.passportKeys.akkEmptyVoltage] }}
			</div>
			<div
				class="fst-italic cur-value-promt"
				:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.akkEmptyVoltage)"
			>
				Поточне значення регістра: 
				{{ station.breaker.getMetric(Breaker.metricKeys.akkEmptyVoltage)?.value?.toFixed(2) }}
			</div>

			<label class="mt-2">{{ Breaker.settingNames[Breaker.passportKeys.akkFullVoltage] }}</label>
				<Field
					:name="Breaker.passportKeys.akkFullVoltage"
					type="number"
					class="form-control form-control-sm no-arrow"
					:class="{ 'is-invalid': errors[Breaker.passportKeys.akkFullVoltage] }"
				/>
				<div class="invalid-feedback">
					{{ errors[Breaker.passportKeys.akkFullVoltage] }}
				</div>
				<div
					class="fst-italic cur-value-promt"
					:class="fieldDynamicClasses(values, errors, Breaker.passportKeys.akkFullVoltage)"
				>
					Поточне значення регістра: 
					{{ station.breaker.getMetric(Breaker.passportKeys.akkFullVoltage)?.value?.toFixed(2) }}
				</div>
		</div>

		<div class="col-12 col-xl-6 d-none d-xl-block">
			&nbsp;
		</div>
	</div>

	<div class="form-row row row-cols-1 m-0 p-0 mt-2">
		<dl v-if="relatedRpc" class="mb-1 text-dark">
			<dt>Останній запит запису регістрів</dt>
			<dd class="mb-0 ms-3">
				Відправив: <span class="font-monospace">
					{{ relatedRpc.context?.writer?.name }}
				</span>
				<span v-if="relatedRpc.context?.writer?.organization?.name" class="font-monospace">
					&nbsp;({{ relatedRpc.context?.writer?.organization?.name }})
				</span>
			</dd>
			<dd class="mb-0 ms-3">
				Час: <span class="font-monospace">
					{{ dateTimeToString(relatedRpc[rpcTaskSchema.updateTime.key], false, false, true) }}
				</span>
			</dd>
			<dd class="mb-0 ms-3">
				Стан: <span
					class="font-monospace"
					:class="{
						'text-danger': rpcTaskSchema.state.isErorrState(relatedRpc?.state),
						'text-success': !rpcTaskSchema.state.isErorrState(relatedRpc?.state),
					}"
				>
					{{ taskStateDescription(relatedRpc?.state) }}
				</span>
			</dd>
			<!-- {{relatedRpc?._id}} -->
		</dl>
	</div>

	<div class="row row-cols-1 form-row m-0 p-0 my-3 g-3">
		<div class="col-12 my-0">
			<p v-if="feedbackPromt.length > 0" class="m-0" :class="feedbackPromtClass">
				{{ feedbackPromt }}
			</p>
			<p v-else-if="meta.dirty && meta.valid" class="text-success m-0">
				Натисніть "Зберегти" щоб примінити налаштування.
			</p>
			<p v-else-if="meta.dirty && !meta.valid" class="text-danger m-0">
				Є поля що заповнені некоректно.
			</p>
			<p v-else class="m-0">&nbsp;</p>
		</div>
	</div>

	<div class="row row-cols-1 form-row m-0 p-0 mb-2">
		<div class="col-12 my-0 mt-1">
			<button
				ref="submitButtonRef"
				type="submit"
				class="btn btn-primary btn-sm"
				:disabled="!meta.valid || !meta.dirty || isSubmitting"
			>
				Записати
			</button>
		</div>
	</div>
</fieldset>
</Form>
</template>




<script>
import { useStationsStore } from '@/stores/StationsStore.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { rpcTaskSchema, useRpcTasks, } from '@/composables/rpcTasks.js'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import { Form, Field } from 'vee-validate'
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';
import { Station } from '@/models/station.js'
import { Breaker } from '@/models/breaker.js';
import {
	capitalizeFirstLetter,
	dateTimeToString,
	getObjectDiff,
} from '@/helpers.js'


export default {
	requiredPromt: 'Обов\'язкове поле',
	overMinLenPromt: 'Довжина меньше мінімальної',
	overMaxLenPromt: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',
	onlyIntegersPromt: 'Має бути цілим числом',
	onlyPositivePromt: 'Має бути натуральним числом',
	wrongInputPromt: 'Не відповідає вимогам',

	components: {
		Form,
        Field,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	emits: {
		rpc: (promt) => typeof promt === 'object',
		sections: (s) => typeof s === "object",
		saveFunction: (f) => typeof f === 'function',
		saveFunctionActive: (f) => typeof f === 'boolean',
	},

	setup() {
		const stationsStore = useStationsStore()
		const accountStore = useAccontStore()
		const { createRpc, readRpc, } = useRpcTasks()

		return {
			Station,
			Breaker,
			capitalizeFirstLetter,
			dateTimeToString,

			stationsStore,
			accountStore,

			rpcTaskSchema,
			createRpc,
			readRpc,
		}
	},

	data() {
		const modBusAddr = Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.integer(this.$options.onlyIntegersPromt)
				.min(1, this.$options.overMinPromt)
				.max(255, this.$options.overMaxPromt)

		const schema = Yup.object().shape({
			[Breaker.passportKeys.unitVersion]: Yup.string()
				.typeError(this.$options.wrongInputPromt)
				.required(this.$options.requiredPromt),

			[Breaker.passportKeys.unitPort]: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.required(this.$options.requiredPromt)
				.integer(this.$options.onlyIntegersPromt)
				.min(1, this.$options.overMinPromt)
				.max(65535, this.$options.overMaxPromt),

			[Breaker.passportKeys.unitModbusAddr]: modBusAddr
				.required(this.$options.requiredPromt),

			[Breaker.passportKeys.powerUnitAddr]: modBusAddr,

			[Breaker.passportKeys.serviceUnitAddr]: modBusAddr,

			[Breaker.passportKeys.breakerAddr]: modBusAddr,

			[Breaker.passportKeys.currentOnDuration]: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.integer(this.$options.onlyIntegersPromt)
				.min(0, this.$options.overMinPromt)
				.max(60, this.$options.overMaxPromt),
			[Breaker.passportKeys.currentOffDuration]: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.integer(this.$options.onlyIntegersPromt)
				.min(0, this.$options.overMinPromt)
				.max(60, this.$options.overMaxPromt),

			[Breaker.passportKeys.breakerMode]: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.integer(this.$options.onlyIntegersPromt)
				.min(0, this.$options.overMinPromt)
				.max(1, this.$options.overMaxPromt),

			[Breaker.passportKeys.noGpsPowerUnitMode]: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.integer(this.$options.onlyIntegersPromt)
				.min(0, this.$options.overMinPromt)
				.max(1, this.$options.overMaxPromt),

			[Breaker.passportKeys.akkEmptyVoltage]: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.min(5, this.$options.overMinPromt)
				.max(20, this.$options.overMaxPromt),

			[Breaker.passportKeys.akkFullVoltage]: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.min(10, this.$options.overMinPromt)
				.max(30, this.$options.overMaxPromt),

			[Breaker.passportKeys.rs485MasterSpeed]: Yup.number(),

			[Breaker.passportKeys.rs485SlaveSpeed]: Yup.number(),

			[Breaker.passportKeys.rs485MasterStopBits]: Yup.number(),

			[Breaker.passportKeys.rs485SlaveStopBits]: Yup.number(),
		})

		return {
			// Form
			schema,
			formMeta: {},
			isSubmittingForm: false,

			relatedRpc: undefined,
			rpcUpdateInterval: null,

			observer: null, // IntersectionObserver

			sections: {
				network: {
					anchor: 'ports-and-addressing',
					title: 'Мережа станції',
					intersectionRatio: 0, // 0 .. 1
				},
				modes: {
					anchor: 'modes',
					title: 'Режим роботи',
					intersectionRatio: 0, // 0 .. 1
				},
				akkumulator: {
					anchor: 'breaker_akkumulator',
					title: 'Акумулятор',
					intersectionRatio: 0, // 0 .. 1
				},
			},

			// Feedback promt
			feedbackPromtClass: '',
			feedbackPromt: '',
		}
	},

	watch: {
		formMeta(newMeta) {
			if (newMeta) {
				this.$emit('saveFunctionActive', newMeta.valid && newMeta.dirty && !this.isSubmittingForm);
				// console.log('meta change', newMeta, !newMeta.valid || !newMeta.dirty || this.isSubmittingForm)
			}
		},
	},

	created() {
		this.readRelatedRpc()
	},

	mounted() {
		// Emit function
		this.$emit('saveFunction', this.submitButtonClick)

		// Add observer for viewport area feedback
		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					switch (entry.target) {
						case this.$refs.networkRef:
							this.sections.network.intersectionRatio = entry.intersectionRatio
							break
						case this.$refs.modesRef:
							this.sections.modes.intersectionRatio = entry.intersectionRatio
							break
						case this.$refs.akkumulatorRef:
							this.sections.akkumulator.intersectionRatio = entry.intersectionRatio
							break
					}
				})
			},
			{
				root: null, // null means all viewport
				rootMargin: '0px',
				threshold: [0, 0.5, 1] // callback call trasholds 0%, 50% and 100% viewport
			}
		)

		this.observer.observe(this.$refs.networkRef)
		this.observer.observe(this.$refs.modesRef)
		this.observer.observe(this.$refs.akkumulatorRef)

		this.$emit('sections', this.sections)
	},

	methods: {
		async readRelatedRpc() {
			if (this.relatedRpcId == undefined) {
				return
			}

			this.relatedRpc = await this.readRpc(this.relatedRpcId)
			this.$emit('rpc', this.relatedRpc)
		},

		async onSubmit(values) {
			let settingsWriteResult = false
			let relatedRpcId = undefined

			// Keys that need to be write to registers
			const settingsKeys = new Set(Object.keys(Breaker.settingNames))

			// Found changed values in settings
			const diff = getObjectDiff(
				this.formValues,
				values,
			)
			let changedSettings = new Set()
			if (diff !== null) {
				const changedKeys = new Set(Object.keys(diff))
				changedSettings = settingsKeys.intersection(changedKeys)
			}
			
			// If there is any changes in settings		
			if (changedSettings.size > 0) {
				// Set changed settings to payload Object
				const payload = {}
				for (const setting of changedSettings) {
					payload[setting] = values[setting]
				}

				// Submit settings to server
				relatedRpcId = await this.submitSettings(payload)
				settingsWriteResult = relatedRpcId === false ? false : true
			} else {
				settingsWriteResult = true
			}

			if (settingsWriteResult) {
				// Submit passport to server
				this.submitPassport(values, relatedRpcId)
			}

			return settingsWriteResult
		},

		
		submitPassport(values, relatedRpcId=undefined) {
			//console.log("values", values)
			const payload = {
				[Breaker.passportKeys.self]: { ...values },
			}
			payload[Station.passportKeys.updateBy] = this.accountStore.userId

			// Save rpc id
			if (relatedRpcId) {
				payload[Breaker.passportKeys.self][Breaker.passportKeys.relatedRpc] = relatedRpcId
			}

			this.stationsStore.updatePasport(
				(result) => {
					if (result) {
						this.printHint('Паспорт успішно оновлено.', 'passport')
						// Update passport
						this.stationsStore.readPassport(undefined, this.stationId)
						// Update rpc with period
						this.rpcUpdateInterval = setInterval(async () => {
							this.readRelatedRpc()
						}, 1000)
					} else {
						this.printErr('Сервер відхилив запит.', 'passport')
					}
				},
				this.stationId,
				payload
			)
		},

		async submitSettings(values) {
			if (this.relatedRpc?.complete === false) {
				this.printErr(
					`Станція вже обробляє інший запит (${rpcTaskSchema.job.findJob(this.relatedRpc.job).title}). `
					+'Будь ласка дочекайтесь його виконання.'
				)
				return false
			} else if (!this.station.isActive) {
				this.printErr('Станція не активна. Тільки активні станції виконують запити.')
				return false
			} else if (this.relatedRpc === undefined
				|| this.relatedRpc.complete === true
			) {
				return await this.writeRpc(values)
			} else {
				this.printErr('Сталася невідома помилка')
				return false
			}
		},

		async writeRpc(values) {
			const context = {}

			context.settings = values
			context.unit = Breaker.passportKeys.self
			context.writer = {
				"name": this.accountStore.userName,
				"id": this.accountStore.userId,
				"organization": {
					"name": this.accountStore.organization["title"],
					"id": this.accountStore.organization["_id"],
				},
			}

			return await this.createRpc(
				this.accountStore.userId,
				rpcTaskSchema.job.allowed.setUnitRegisters.key,
				this.stationId,
				null,
				context,
			).then((result) => {
				if (result) {
					this.printHint('Запит надіслано. Спостерігайте за його станом.')
				} else {
					this.printErr('Сервер відхилив запит постановки завдання.', 'settings')
				}

				return result
			})
		},

		submitButtonClick() {
			this.$refs.submitButtonRef.click()
		},

		// Delete date field if date is cleared by button "Clear"
		onChangeDate(key, newDate) {
			if (newDate == "") {
				this.$refs.form.setFieldValue(key, null);
			}
		},

		fieldDynamicClasses(values, errors, valueKey) {
			const isInvalid = errors[valueKey]

			const isMatchRegister =
				(values ? values[valueKey] : undefined) 
				== this.station.breaker.getMetric(valueKey)?.value

			return {
				'is-invalid': isInvalid,
				'not-match-register': !isMatchRegister && !isInvalid,
			}
		},

		taskStateDescription(state) {
			const stateObj = this.rpcTaskSchema.state.findState(state)
			return stateObj == undefined || stateObj == false
				? "невизначено"
				: stateObj.title
		},

		printHint (msg) {
			this.feedbackPromtClass = "text-success"
			this.feedbackPromt = msg
		},

		printErr (msg) {
			this.feedbackPromtClass = "text-danger"
			this.feedbackPromt = msg
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		isFormEnabled() {
			return this.accountStore.permissions.includes('manage_stations')
		},

		formValues() {
			return { ...this.station.breaker.passport }
		},

		relatedRpcId() {
			const passport = this.station.breaker.passport
			return passport ? passport[Breaker.passportKeys.relatedRpc] : undefined
		},
	},

	beforeUnmount() {
		if (this.rpcUpdateInterval != null) {
			clearInterval(this.rpcUpdateInterval)
			this.rpcUpdateInterval = null
		}

		// If observer, then disable
		if (this.observer) {
			this.observer.disconnect()
		}
	}
}
</script>




<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}

/* Style for input if it is not match register value */
.not-match-register {
	border-color: rgb(11, 94, 215);
	color: rgb(11, 94, 215);
}
</style>